import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal';
import Button from '../Button';

import './styles.css';

export default class ScheduleModal extends React.PureComponent {
  static propTypes = {
    title: PropTypes.any,
    message: PropTypes.any,
    cancelText: PropTypes.string,
    confirmText: PropTypes.string,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    closeAndResetValues: PropTypes.func,
    mountNode: PropTypes.any,
    open: PropTypes.bool,
    clearLoading: PropTypes.bool,
    isInvalid: PropTypes.bool,
  }

  state = { requesting: false };

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.clearLoading || (!this.props.open && nextProps.open)) {
      this.setState({ requesting: false });
    }
  }

  onConfirmLoading = () => {
    const { onConfirm } = this.props;

    this.setState({ requesting: true });
    if (onConfirm) onConfirm();
  };

  render() {
    const { title, message, cancelText, confirmText, onCancel, isInvalid } = this.props;
    const { mountNode, onOpen, open, onClose, closeAndResetValues } = this.props;
    const props = { onClose, mountNode, onOpen, open };
    return (
      <Modal
        styleName="modal"
        onUnmount={() => open && closeAndResetValues && closeAndResetValues()}
        {...props}
      >
        <Modal.Header as="h2" styleName="header">
          {title}
        </Modal.Header>
        <Modal.Content styleName="text">
          {message}
        </Modal.Content>
        <Modal.Actions>
          <Button content={cancelText} onClick={onCancel} />
          <Button
            data-cy="confirm-visit"
            primary
            disabled={isInvalid}
            content={confirmText}
            onClick={this.onConfirmLoading}
            loading={this.state.requesting}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}
